import { render } from "./petunjuk_salah_benar.vue?vue&type=template&id=4949abd4&scoped=true"
import script from "./petunjuk_salah_benar.vue?vue&type=script&lang=js"
export * from "./petunjuk_salah_benar.vue?vue&type=script&lang=js"

import "./petunjuk_salah_benar.vue?vue&type=style&index=0&id=4949abd4&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4949abd4"]])

export default __exports__